/**
 * PERSONNALISATIONS JS POUR JM LEGAZEL
 * ====================================
 * Ce fichier contient toutes les personnalisations JavaScript
 * pour la boutique Shopify JM Legazel.
 * Dernière mise à jour : 08 mai 2025
 */

/**
 * FILTRES COLLECTION "FINS DE SÉRIES"
 * -----------------------------------
 * Cette fonction coche automatiquement l'option "en stock"
 * dans les filtres de la collection "fins de séries".
 */
document.addEventListener('DOMContentLoaded', function() {
  // Vérifier si nous sommes sur une page de collection "fins de séries"
  const currentUrl = window.location.pathname;
  if (currentUrl.includes('/collections/') && 
      (currentUrl.includes('fins-de-series') || 
       currentUrl.includes('fins-de-series-homme') || 
       currentUrl.includes('fins-de-series-femme'))) {
    
    console.log("Page de collection Fins de Séries détectée!");
    
    // Attendre que la page soit complètement chargée
    setTimeout(function() {
      console.log("Recherche du filtre 'en stock' dans la collection...");
      
      // Plusieurs approches pour trouver le filtre "en stock"
      
      // 1. Recherche par texte dans tous les éléments
      const allElements = document.querySelectorAll('*');
      let stockFilterFound = false;
      
      for (let i = 0; i < allElements.length; i++) {
        const element = allElements[i];
        if (element.textContent && 
            element.textContent.trim().toLowerCase() === 'en stock' &&
            (element.tagName === 'LABEL' || 
             element.tagName === 'SPAN' || 
             element.tagName === 'DIV' || 
             element.tagName === 'A')) {
          
          console.log("Élément 'en stock' trouvé:", element);
          
          // Chercher la checkbox associée
          let checkbox = null;
          
          // Possibilité 1: input enfant
          checkbox = element.querySelector('input[type="checkbox"]');
          
          // Possibilité 2: input frère
          if (!checkbox && element.parentNode) {
            checkbox = element.parentNode.querySelector('input[type="checkbox"]');
          }
          
          // Possibilité 3: input avec même id que for du label
          if (!checkbox && element.getAttribute('for')) {
            checkbox = document.getElementById(element.getAttribute('for'));
          }
          
          if (checkbox) {
            console.log("Checkbox 'en stock' trouvée:", checkbox);
            checkbox.checked = true;
            
            // Déclencher les événements
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            checkbox.dispatchEvent(new Event('click', { bubbles: true }));
            
            // Marquer comme trouvé
            stockFilterFound = true;
            console.log("Filtre 'En stock' activé avec succès!");
            break;
          } else {
            // Si pas de checkbox mais élément cliquable
            console.log("Pas de checkbox trouvée, tentative de clic sur l'élément");
            element.click();
            stockFilterFound = true;
            break;
          }
        }
      }
      
      // Si rien n'a été trouvé, essayer une autre approche avec des sélecteurs plus spécifiques
      if (!stockFilterFound) {
        console.log("Tentative avec des sélecteurs spécifiques au thème...");
        
        // Sélecteurs courants pour les filtres disponibilité/stock dans différents thèmes
        const stockSelectors = [
          'input[aria-label*="stock"]',
          'input[name*="stock"]',
          'input[data-filter*="stock"]',
          'input[data-value*="stock"]',
          'label:contains("stock") input',
          '.filter-group:contains("stock") input',
          '.facet-checkbox:contains("stock") input',
          '.filter__item:contains("stock") input'
        ];
        
        for (let selector of stockSelectors) {
          try {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
              console.log(`Élément trouvé avec le sélecteur: ${selector}`, elements[0]);
              elements[0].checked = true;
              elements[0].dispatchEvent(new Event('change', { bubbles: true }));
              stockFilterFound = true;
              break;
            }
          } catch (e) {
            console.log(`Erreur avec le sélecteur ${selector}:`, e);
          }
        }
      }
      
      if (!stockFilterFound) {
        console.log("Impossible de trouver automatiquement le filtre 'en stock'. Une inspection manuelle de la structure HTML sera nécessaire.");
      }
    }, 2000); // Attendre 2 secondes pour que tout soit bien chargé
  } else {
    console.log("Pas sur une page de collection Fins de Séries");
  }
});

// Mise en évidence des quantités en stock sur la page "fins de séries"
(function() {
  // Attendre que le DOM soit chargé
  document.addEventListener('DOMContentLoaded', function() {
    // Vérifie si nous sommes sur la page "fins de séries"
    var isFinsDeSeries = false;
    
    // Vérification via l'URL
    if (window.location.pathname.includes('/collections/fins-de-series') || 
        window.location.pathname.includes('/collections/fins-de-serie') || 
        window.location.pathname.includes('/collections/end-of-series')) {
      isFinsDeSeries = true;
    }
    
    // Vérification via le titre de la page (méthode alternative)
    var pageTitle = document.title || '';
    if (pageTitle.toLowerCase().includes('fins de série') || 
        pageTitle.toLowerCase().includes('fins de series')) {
      isFinsDeSeries = true;
    }
    
    // Si ce n'est pas la page fins de séries, on s'arrête là
    if (!isFinsDeSeries) {
      return;
    }
    
    // Fonction qui s'exécute périodiquement pour attraper les nouveaux éléments
    function updateStockNumbers() {
      // Cible spécifiquement le texte des tailles, pas les labels entiers
      var sizeTextElements = document.querySelectorAll('.filter-group__item span, .tag__text');
      
      // Pour chaque élément
      sizeTextElements.forEach(function(element) {
        // Ne traite que les éléments qui n'ont pas encore été modifiés
        if (!element.hasAttribute('data-processed') && element.textContent.includes('(')) {
          // Marque l'élément comme traité
          element.setAttribute('data-processed', 'true');
          
          // Récupère le texte original
          var originalText = element.textContent;
          
          // Trouve l'index des parenthèses
          var openParenIndex = originalText.lastIndexOf('(');
          var closeParenIndex = originalText.lastIndexOf(')');
          
          if (openParenIndex !== -1 && closeParenIndex !== -1) {
            // Divise le texte en parties
            var beforeParen = originalText.substring(0, openParenIndex);
            var insideParen = originalText.substring(openParenIndex, closeParenIndex + 1);
            
            // Crée le nouveau contenu HTML sans toucher à la structure parent-enfant
            element.innerHTML = beforeParen + 
                               '<span style="display: inline-block; width: 4px;">&nbsp;</span>' + 
                               '<span style="font-weight: 700; color: #482c54;">' + insideParen + '</span>';
          }
        }
      });
    }
    
    // Exécute la fonction immédiatement
    updateStockNumbers();
    
    // Puis toutes les 500ms pour attraper les éléments chargés dynamiquement
    setInterval(updateStockNumbers, 500);
  });
})();

/**
 * AMÉLIORATIONS FUTURES
 * --------------------
 * Cet espace est réservé pour les futures fonctionnalités JavaScript.
 * 
 * Idées potentielles:
 * - Amélioration du panier d'achat
 * - Fonctionnalités pour le programme de fidélité
 * - Améliorations de la navigation mobile
 */